<template>
  <div class="card is-paddingless height-100">
    <header class="header-card">
      <p>
        {{ $t('firstStepUtilisateur.identifiantConnexion.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field :label="$t('firstStepUtilisateur.identifiantConnexion.identifiant')"
                 class="obligatoire column is-12 is-marginless">
          <b-input v-model="infoUser.identifiant"></b-input>
        </b-field>
        <b-field :label="$t('firstStepUtilisateur.identifiantConnexion.motDePasse')"
          class="column is-12 is-marginless"
          :class="{'obligatoire': isAdd === true}"
          :message="$t('firstStepUtilisateur.identifiantConnexion.messagePassword')">
          <b-input type="password" v-model="infoUser.motPasse" password-reveal></b-input>
        </b-field>
        <b-field :label="$t('firstStepUtilisateur.identifiantConnexion.confirmerMdp')"
                 class="column is-12 is-marginless"
                 :class="{'obligatoire': isAdd === true}">
          <b-input type="password" v-model="infoUser.motPasseConf" password-reveal></b-input>
        </b-field>
        <b-field class="column is-12 is-marginless is-multiline">
        <span class="has-text-default">
          {{ $t('firstStepUtilisateur.identifiantConnexion.connexion') }}
          <div class="is-pulled-right">
          <qd-radio v-model="infoUser.connexionAutorisee"
                   native-value="true">
                {{ $t('firstStepUtilisateur.identifiantConnexion.yes') }}
            </qd-radio>
            <qd-radio v-model="infoUser.connexionAutorisee"
                     native-value="false">
                {{ $t('firstStepUtilisateur.identifiantConnexion.no') }}
            </qd-radio>
          </div>
        </span>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    infoUser: Object,
    isAdd: Boolean,
  },
};
</script>

<style scoped>

</style>
